import React from "react";
import { cn } from "../../utils/cn";
interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  theme?: "light" | "dark";
}
export function Badge({
  children,
  theme = "dark",
  className,
  ...props
}: BadgeProps) {
  return <div className={cn("inline-flex items-center rounded-full px-3 py-1.5 text-[10px] md:text-xs font-bold uppercase tracking-wider", theme === "dark" ? "border border-white/15 bg-[#1737B7] text-[#FFC900]" : "border border-[#142FA8]/15 bg-[#F5F7F9] text-[#142FA8]", className)} {...props} data-id="element-288" data-mp="14gbdanksn483">
      {children}
    </div>;
}